var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone-list__body active",attrs:{"id":"phoneListBody"}},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"phone-list__row"},[_c('div',{staticClass:"phone-list__cell h3"},[_vm._v(_vm._s(item.District))]),_vm._v(" "),_c('div',{staticClass:"phone-list__cell h3"},[_vm._v(_vm._s(item.WorkingTime))]),_vm._v(" "),_c('div',{staticClass:"phone-list__cell h3 _phone"},[_vm._v(_vm._s(item.Phone))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Scripts/app/FooterContactInfo/PhoneList.vue